import React from 'react'
import { CssBaseline } from '@mui/material'
import Header from './components/Landing/Header'
import Hero from './components/Landing/Hero'
import About from './components/Landing/About'
import Services from './components/Landing/Services'
import AroPMIS from './components/Landing/AroPMIS'
import Contact from './components/Landing/Contact'
import Footer from './components/Landing/Footer'

function App() {
  return (
    <>
      <CssBaseline />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <AroPMIS />
        <Contact />
      </main>
      <Footer />
    </>
  )
}

export default App
